import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
} from '@mui/material'
import AuthMainContainer from '../../../layouts/auth/AuthMainContainer'
import useAuthLoginPageViewModel from './viewModel'
import { Controller } from 'react-hook-form'
import GoogleIcon from '@mui/icons-material/Google'
import AuthService from '../../../services/auth'
import { Link } from 'react-router'
import links from '../../../routes/links'
import HomeIcon from '@mui/icons-material/Home'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'

export default function AuthLoginPage() {
  const viewModel = useAuthLoginPageViewModel()

  return (
    <AuthMainContainer>
      <Card elevation={5} sx={{ width: '100%', maxWidth: '400px' }}>
        <CardHeader
          title='Login'
          subheader='Login to Delta Core-X'
          action={
            <Link to={links.public.home()}>
              <IconButton>
                <HomeIcon />
              </IconButton>
            </Link>
          }
        />
        <Divider />
        <CardContent>
          <form onSubmit={viewModel.formHook.handleSubmit(viewModel.onSubmit)}>
            <Stack gap={2}>
              <Controller
                control={viewModel.formHook.control}
                name='email'
                render={({ field, fieldState }) => (
                  <TextField
                    variant='outlined'
                    required
                    label='Email'
                    placeholder='Enter your email...'
                    type='email'
                    {...field}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  />
                )}
              />
              <Controller
                control={viewModel.formHook.control}
                name='password'
                render={({ field, fieldState }) => (
                  <TextField
                    variant='outlined'
                    required
                    label='Password'
                    placeholder='Enter your password...'
                    type={viewModel.showPassword ? 'text' : 'password'}
                    slotProps={{
                      input: {
                        endAdornment: (
                          <InputAdornment position='end'>
                            <IconButton onClick={viewModel.toggleShowPassword}>
                              {viewModel.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      },
                    }}
                    {...field}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  />
                )}
              />
              <Button
                type='submit'
                variant='contained'
                size='large'
                disabled={viewModel.loginStatus.isLoading}
                loading={viewModel.loginStatus.isLoading}
              >
                Submit
              </Button>
              <Divider sx={{ width: 200, mx: 'auto' }} />
              <Button
                type='button'
                variant='contained'
                color='error'
                startIcon={<GoogleIcon />}
                onClick={AuthService.firebaseLoginGoogle}
              >
                Login with google
              </Button>
            </Stack>
          </form>
        </CardContent>
      </Card>
    </AuthMainContainer>
  )
}
